// Widget Scripts
import cardWidget from './js/widgets/cardWidget';
import footerImages from './js/widgets/footerImages';
import seoWidget from './js/widgets/seoWidget';
import sponsors from './js/widgets/sponsors';
import swiperWidget from './js/widgets/swiperWidget';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidget();
    seoWidget();
    swiperWidget();
  });
}

// Initialize Sitewide Widgets
$(document).ready(function() {
  footerImages();
  sponsors();
});